import { Contact } from "@/@types/responses/contact/Contact"
import { AuditableResponse } from "../common/AuditableResponse"

export class ManufacturerDetails extends AuditableResponse {
  id: number
  name: string
  website: string
  email: string
  phoneNumber: string
  addressLine1: string
  addressLine2: string
  city: string
  stateId?: number
  postalCode: string
  contacts: Contact[]

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(id: number, name?: string, website?: string, email?: string, phoneNumber?: string, addressLine1?: string, addressLine2?: string, city?: string, stateId?: number, postalCode?: string, contactsJson?: any, createdByUserJson?: any, createdDate?: string, lastModifiedByUserJson?: any, lastModifiedDate?: string) {
    super(createdByUserJson, createdDate, lastModifiedByUserJson, lastModifiedDate)
    this.id = id
    this.name = name ?? ''
    this.website = website ?? ''
    this.email = email ?? ''
    this.phoneNumber = phoneNumber ?? ''
    this.addressLine1 = addressLine1 ?? ''
    this.addressLine2 = addressLine2 ?? ''
    this.city = city ?? ''
    this.stateId = stateId
    this.postalCode = postalCode ?? ''
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.contacts = contactsJson ? contactsJson.map((c: any) => new Contact(c.id, c.firstName, c.lastName, c.phoneNumber, c.email)) : []
  }
}
